/**
 * Job-list polling hook (T027, D2/C2/W9). Polls on POLL_ACTIVE_MS while any job
 * is active; stops once all are terminal (FR-009); backs off on 429.
 * keepPreviousData so a background refetch failure keeps stale data on screen
 * (W9 — silent).
 */
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { listJobs } from '../lib/endpoints/jobs'
import { qk } from '../lib/queryKeys'
import { hasActiveJob } from '../lib/jobStatus'
import { pollInterval, POLL_ACTIVE_MS } from '../lib/pollBackoff'

export function useJobs(limit = 100, all = false) {
  return useQuery({
    // Variant key under the `['jobs']` prefix so the admin "all" list and the
    // own-list are separate caches, yet a bare `qk.jobs()` invalidation (submit /
    // cancel) still refreshes both by prefix match.
    queryKey: [...qk.jobs(), all],
    queryFn: () => listJobs(limit, all),
    // Poll while a job is active — but back off hard after a 429 so the client
    // stops hammering the rate limiter (the storm was self-inflicted).
    refetchInterval: (query) =>
      pollInterval(
        query.state.error,
        hasActiveJob(query.state.data) && POLL_ACTIVE_MS,
      ),
    staleTime: 2500,
    placeholderData: keepPreviousData,
    // refetchOnWindowFocus inherits the client default (false) — tab focus was
    // firing extra list refetches on top of the interval.
  })
}
